import {
  scattered_media_default
} from "./chunk-3NAXLTFZ.js";

// src/modules/scattered-media/scattered-media.tsx
import { jsx } from "react/jsx-runtime";
var mScatteredMedia = ({
  _id,
  className = "",
  content,
  labels,
  sequence
}) => {
  return /* @__PURE__ */ jsx(
    "section",
    {
      className,
      "data-module-sequence": sequence,
      "data-module-type": "mScatteredMedia",
      id: _id,
      children: /* @__PURE__ */ jsx("div", { className: "theme-dark full-viewport-width", children: /* @__PURE__ */ jsx(
        scattered_media_default,
        {
          className: "overflow-hidden",
          id: `${_id}_scattered_media`,
          ...content
        }
      ) })
    }
  );
};
var scattered_media_default2 = mScatteredMedia;

export {
  scattered_media_default2 as scattered_media_default
};
